import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../../contexts/AuthContext';
import { confirmDialog, errorAlert } from '../../../helpers/alerts';

// Grupos de cameras (Caixas, Deposito...). Cada grupo com camera vira uma
// opcao em "Ver" na tela do tour.

export default function GruposAba({ onAlterou }) {
  const [grupos, setGrupos] = useState([]);
  const [novo, setNovo] = useState('');
  const [editando, setEditando] = useState(null); // { id, nome, ordem }
  const [erro, setErro] = useState('');

  const carregar = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/cameras/cameras`);
      setGrupos(res.data?.data?.grupos || []);
    } catch (e) {
      setErro(e.response?.data?.message || 'Não foi possível carregar os grupos.');
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const executar = async (acao) => {
    setErro('');
    try {
      await acao();
      await carregar();
      onAlterou();
      return true;
    } catch (e) {
      setErro(e.response?.data?.message || 'Não foi possível salvar o grupo.');
      return false;
    }
  };

  const criar = async (e) => {
    e.preventDefault();
    const proximaOrdem = grupos.reduce((m, g) => Math.max(m, g.ordem), 0) + 10;
    if (await executar(() => axios.post(`${API}/cameras/grupos`, { nome: novo, ordem: proximaOrdem }))) setNovo('');
  };

  const salvarEdicao = async () => {
    if (await executar(() => axios.put(`${API}/cameras/grupos/${editando.id}`, editando))) setEditando(null);
  };

  const excluir = async (g) => {
    const r = await confirmDialog({
      title: `Excluir o grupo "${g.nome}"?`,
      text: 'As câmeras do grupo ficam sem grupo. Elas não são apagadas.',
      confirmButtonText: 'Excluir',
    });
    if (!r.isConfirmed) return;
    try {
      await axios.delete(`${API}/cameras/grupos/${g.id}`);
      await carregar();
      onAlterou();
    } catch (e) {
      errorAlert({ title: 'Erro', text: e.response?.data?.message || 'Não foi possível excluir.' });
    }
  };

  return (
    <>
      {erro ? <div className="feedback-banner feedback-banner--error" style={{ marginBottom: 12 }}>{erro}</div> : null}
      <form onSubmit={criar} className="cameras-config__topo">
        <input
          type="text"
          className="cameras-config__select"
          placeholder="Nome do novo grupo (ex.: Caixas)"
          maxLength={60}
          value={novo}
          onChange={(e) => setNovo(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="submit" className="btn btn-primary btn-sm" disabled={!novo.trim()}>
          <i className="bi bi-plus-lg me-1" /> Adicionar grupo
        </button>
      </form>

      <div className="table-shell">
        <table className="portal-table">
          <thead>
            <tr>
              <th>Grupo</th>
              <th style={{ width: 90 }}>Ordem</th>
              <th style={{ width: 130 }} />
            </tr>
          </thead>
          <tbody>
            {grupos.map((g) => (editando?.id === g.id ? (
              <tr key={g.id}>
                <td>
                  <input
                    type="text"
                    className="cameras-config__input"
                    maxLength={60}
                    value={editando.nome}
                    onChange={(e) => setEditando((x) => ({ ...x, nome: e.target.value }))}
                    autoFocus
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="cameras-config__input"
                    value={editando.ordem}
                    onChange={(e) => setEditando((x) => ({ ...x, ordem: Number(e.target.value) || 0 }))}
                  />
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button type="button" className="btn btn-primary btn-sm" onClick={salvarEdicao} title="Salvar">
                      <i className="bi bi-check-lg" />
                    </button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setEditando(null)} title="Cancelar">
                      <i className="bi bi-x-lg" />
                    </button>
                  </div>
                </td>
              </tr>
            ) : (
              <tr key={g.id}>
                <td className="cell-strong">{g.nome}</td>
                <td>{g.ordem}</td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setEditando({ ...g })} title="Renomear">
                      <i className="bi bi-pencil" />
                    </button>
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => excluir(g)} title="Excluir">
                      <i className="bi bi-trash" />
                    </button>
                  </div>
                </td>
              </tr>
            )))}
          </tbody>
        </table>
      </div>
    </>
  );
}
